import { Autoplay, Navigation, Pagination, Manipulation } from 'swiper/modules';
import { Component, Element, Host, Prop, State, h, Event, EventEmitter, Watch } from '@stencil/core';
import intersectionObserver from '../../utils/intersection-observer';

import { MainService } from '../../utils/services';
import { Swiper } from 'swiper';

import { jwtDecode } from 'jwt-decode';

@Component({
  tag: 'swiper-slider-v2',
  styleUrl: 'swiper-slider-v2.scss',
  shadow: true,
})
export class SwiperSliderV2 {
  private initializeSwiper?: boolean;
  private swiper: Swiper;
  private Services: MainService;
  public isJackpotcity: Boolean;
  public isDark: Boolean;
  private heightPercentages: Record<string, Record<string | number, number>>;

  @Prop({ mutable: true }) auth: any = false;
  @Prop() playerid: string = '';
  @Prop({ mutable: true }) channel: string = 'webdesktop';
  @Prop({ mutable: true }) culture: string = 'EN';
  @Prop({ mutable: true }) navigation: boolean = true;
  @Prop({ mutable: true }) pagination: boolean = true;
  @Prop({ mutable: true }) region: string = 'BBG';
  @Prop({ mutable: true }) slidecount: number;
  @Prop({ mutable: true }) vertical: string = 'Sport';
  @Prop({ mutable: true }) jackpotcity: boolean | string;
  @Prop({ mutable: true }) dark: boolean = false;
  @Prop({ mutable: true }) autoplay: boolean = true;
  @Prop({ mutable: true }) interval: number = 4000;
  @Prop() desktopaspectratio: string = '233/151';
  @Prop() mobileaspectratio: string = '359/66';
  @Prop() isvuvubanner: boolean = false;

  constructor() {
    this.Services = new MainService();
    this.initializeSwiper = false;
    this.swiper = null;
    this.isDark = Boolean(this.dark);
    this.heightPercentages = {
      betway: {
        5: 0.14,
        4: 0.15,
        3: 0.21,
        2: 0.32,
        1: 0.18,
      },
      jackpotcity: {
        5: 0.12,
        4: 0.16,
        3: 0.19,
        2: 0.3,
        1: 0.15,
      },
    };
  }

  @Element() e: HTMLElement;
  @State() testState: number;
  @State() url: string;
  @State() data: any;
  @State() bannerData: any = [];
  @State() kenticoUrl = 'https://cms1.easterndawn.io';
  @State() hostUrl = 'banners.gmgamingsystems.com';
  @State() rootApiURL: string = 'https://rowapi.gmgamingsystems.com';
  @State() swiperOptions: {};
  @State() hashUpdated: boolean = false;
  @State() allData: any = [];
  @State() placeHolder: { mobile: string; desktop: string } = {
    mobile: 'https://cms1.betwayafrica.com/medialibraries/banners.betwayafrica.com/HTML5Banners/Africa/mobile_placeholder.png',
    desktop: 'https://cms1.betwayafrica.com/medialibraries/banners.betwayafrica.com/HTML5Banners/Africa/desktop_placeholder.png',
  };

  @State() DecodedToken: {} & { 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier': string };

  @Event({
    eventName: 'bannerClicked',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  bannerClicked: EventEmitter<any>;

  @Event({
    eventName: 'moreInfoClicked',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  moreInfoClicked: EventEmitter<any>;

  @Event({
    eventName: 'widgetLoaded',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  widgetLoaded: EventEmitter<any>;

  @Event({
    eventName: 'noBanners',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  noBanners: EventEmitter<any>;

  @Watch('auth')
  decodeToken() {
    if (!!this.auth) this.DecodedToken = jwtDecode(this.auth);
  }

  getScreenSize() {
    return window.screen.width;
  }
  returnAspectRatio() {
    return this.getScreenSize() <= 640 ? this.mobileaspectratio : this.desktopaspectratio;
  }
  returnFullWidthAspectRatio() {
    const honorPagination = this.getScreenSize() <= 640;
    const [width, height] = this.returnAspectRatio().split('/');
    return `${honorPagination ? +width * this.slidecount : width}/${height}`;
  }
  returnPlaceholder() {
    const isMobile = this.getScreenSize() <= 640;
    return isMobile ? this.placeHolder.mobile : this.placeHolder.desktop;
  }
  async componentWillLoad() {
    this.getUrl();
    await this.getDataFromServices();
  }
  getUrl() {
    const baseSubdomain = (!!this.auth && this.auth.toString() !== 'false') || !!this.playerid ? 'api' : 'apic';
    const isLoggedInBanner = !!this.auth && this.auth.toString() !== 'false';
    switch (this.region) {
      case 'BBG':
      case 'BPL':
        this.url = `https://rowapi.gmgamingsystems.com/api/v1/Banners/${this.region}/${this.vertical}/${this.channel}?authenticated=${this.auth}`;
        break;
      case 'JZA':
        this.kenticoUrl = 'https://cms1.jpc.africa';
        this.url = `https://${baseSubdomain}.jpc.africa/All/Active?regionCode=${this.region}&vertical=${this.vertical}&channelCode=${this.channel}&isLoggedInBanner=${isLoggedInBanner}&api-version=1`;
        this.placeHolder = {
          mobile: 'https://cms1.jpc.africa/medialibraries/Jackpotcity.co.za/content-pages/placeholders/JPC_GameTilePlaceHolder_720x200.jpg',
          desktop: 'https://cms1.jpc.africa/medialibraries/Jackpotcity.co.za/content-pages/placeholders/JPC_GameTilePlaceHolder_1600x500.jpg',
        };
        this.hostUrl = 'banners.jpc.africa';
        break;
      default:
        this.kenticoUrl = 'https://cms1.betwayafrica.com';
        this.url = `https://${baseSubdomain}.betwayafrica.com/All/Active?regionCode=${this.region}&vertical=${this.vertical}&channelCode=${this.channel}&isLoggedInBanner=${isLoggedInBanner}&api-version=1`;
    }
  }
  async getDataFromServices() {
    if (!!this.auth) this.decodeToken();
    const decodeKey = !!this.auth ? Object.keys(this.DecodedToken).find(d => d.includes('nameidentifier')) : '';
    const xplayerId = !!this.playerid || !!this.DecodedToken?.[decodeKey] ? { 'x-playerId': !!this.playerid ? this.playerid : this.DecodedToken?.[decodeKey] } : {};
    const additionalHeaders = { 'Content-Type': 'text/plain' };
    const authorization = !!this.auth ? { authorization: this.auth } : {};
    this.data = await this.Services.getUrl(this.url, {
      ...xplayerId,
      ...authorization,
      ...additionalHeaders,
    });
    if (this.data.length < 1) {
      this.handleNoBanners();
    }
  }
  calculateHeight() {
    const isMobile = this.getScreenSize() <= 640;
    const sizes = this.heightPercentages[String(this.jackpotcity) === 'true' ? 'jackpotcity' : 'betway'];
    const hostWidth = this.e.shadowRoot.host.clientWidth;
    return isMobile ? hostWidth * sizes[1] : hostWidth * sizes[this.slidecount];
  }
  handleClickSide(cta) {
    if (String(cta).trim().length === 0) return;
    cta = String(cta).replace('<br>', '');
    cta = String(cta).replace('&nbsp', '');

    let Action;
    let Value;
    let fullCTA;
    const JSON_CTA = JSON.parse(cta);

    if (this.auth) {
      if (Object.prototype.hasOwnProperty.call(JSON_CTA, 'loggedIn')) {
        Action = JSON_CTA.loggedIn['Action'];
        Value = JSON_CTA.loggedIn['Value'];
        fullCTA = JSON_CTA.loggedIn;
      }
    } else {
      if (Object.prototype.hasOwnProperty.call(JSON_CTA, 'loggedOut')) {
        Action = JSON_CTA.loggedOut['Action'];
        Value = JSON_CTA.loggedOut['Value'];
        fullCTA = JSON_CTA.loggedOut;
      }
    }

    if (Action) {
      const vuvuCTA = this.isvuvubanner ? fullCTA : {};
      this.bannerClicked.emit({ Action, Value, ...vuvuCTA });
    }
  }
  handleMoreInfoClick(moreInfo) {
    this.moreInfoClicked.emit(moreInfo);
  }
  handleWidgetLoaded(loaded: boolean) {
    this.widgetLoaded.emit(loaded);
  }

  handleNoBanners() {
    this.noBanners.emit(true);
  }

  handleReducedPadding() {
    const swiperElement: HTMLElement = document.querySelector('.mySwiper') as HTMLElement;
    swiperElement.style.paddingBottom = '0px';
  }
  render() {
    this.isJackpotcity = !!this.jackpotcity ? this.jackpotcity?.toString() === 'true' : false;
    return (
      <Host>
        <div class={this.isJackpotcity ? 'swiper mySwiper jpc-swiper' : 'swiper mySwiper syn-swiper'}>
          <div class="swiper-wrapper"></div>
          <div class={`${this.isJackpotcity ? 'swiper-button-next jpc-next' : 'swiper-button-next syn-next'} ${this.isDark ? 'dark' : 'light'}`}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">
              <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
            </svg>
          </div>
          <div class={`${this.isJackpotcity ? 'swiper-button-prev jpc-prev' : 'swiper-button-prev syn-prev'} ${this.isDark ? 'dark' : 'light'}`}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">
              <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
            </svg>
          </div>
          <div class={`${this.isJackpotcity ? 'swiper-pagination jpc-pagination' : 'swiper-pagination syn-pagination'} ${this.isDark ? 'dark' : 'light'}`}></div>
          {this.isJackpotcity && this.data.length > 1 && (
            <div class={`autoplay-progress ${this.isDark ? 'dark' : 'light'}`}>
              <span class={`${this.isDark ? 'dark' : 'light'}`}></span>
              <svg viewBox="0 0 48 48" class={`${this.isDark ? 'dark' : 'light'}`}>
                <defs>
                  <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stop-color="#2530ac" />
                    <stop offset="100%" stop-color="#3879fb" />
                  </linearGradient>
                </defs>
                <circle cx="24" cy="24" r="20" stroke="url(#gradient)" stroke-width="6"></circle>
              </svg>
            </div>
          )}
        </div>
      </Host>
    );
  }
  componentDidRender() {
    if (this.initializeSwiper === false) {
      this.initializeSwiper = true;
      const jpc = this.isJackpotcity;
      const bannerCount = this.data.length;
      const context = this;
      let swiperElement: HTMLElement = this.e.shadowRoot.querySelector('.mySwiper') as HTMLElement;
      let swiperPagination: HTMLElement = this.e.shadowRoot.querySelector('.swiper-pagination') as HTMLElement;
      let swiperNext: HTMLElement = this.e.shadowRoot.querySelector('.swiper-button-next') as HTMLElement;
      let swiperPrev: HTMLElement = this.e.shadowRoot.querySelector('.swiper-button-prev') as HTMLElement;
      let progressCircle: HTMLElement = this.e.shadowRoot.querySelector('.autoplay-progress svg');
      let progressContent: HTMLElement = this.e.shadowRoot.querySelector('.autoplay-progress span');
      if (bannerCount <= 1) {
        swiperElement.style.paddingBottom = '0px';
      }
      this.swiper = new Swiper(swiperElement, {
        slidesPerView: this.slidecount / this.slidecount,
        spaceBetween: 8,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: this.interval,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        pagination: {
          el: swiperPagination,
          clickable: true,
          enabled: context.data.length < 15,
        },
        navigation: {
          nextEl: swiperNext,
          prevEl: swiperPrev,
          enabled: false,
        },
        on: {
          // @ts-ignore
          autoplayTimeLeft(s, time, progress) {
            if (jpc && bannerCount > 1) {
              progressCircle.style.setProperty('--progress', (100 - progress) as unknown as string);
              progressContent.textContent = `${Math.ceil(time / 1000)}`;
            }
          },
          afterInit() {
            setTimeout(() => context.handleWidgetLoaded(true), 500);
          },
        },
        modules: [Pagination, Navigation, Autoplay, Manipulation],
        breakpoints: {
          325: {
            pagination: {
              enabled: this.pagination && context.data.length < 8,
              type: 'bullets',
            },
          },
          768: {
            slidesPerView: this.slidecount,
            spaceBetween: 8,
            centeredSlides: false,
            loop: false,
            pagination: {
              enabled: this.pagination && context.data.length < 15,
              type: 'bullets',
            },
            navigation: {
              enabled: this.navigation,
            },
          },
        },
      });
      this.data.forEach(async ({ url }, index) => {
        const { mobileimage, desktopimage, cta, moreinfo } = await this.Services.getKenticoBanner(this.kenticoUrl, this.hostUrl, url, this.culture);
        const parser = new DOMParser();
        const image = this.getScreenSize() <= 640 ? parser.parseFromString(mobileimage, 'text/html') : parser.parseFromString(desktopimage, 'text/html');
        image.querySelector('img')?.classList.add('splide_image');
        const parsedImage = () => image.getElementsByTagName('img')[0];

        const src = parsedImage()?.attributes['src']['value'];
        if (src) {
          // generate holding item
          const item = document.createElement('div');
          item.classList.add('swiper-slide');
          item.style.aspectRatio = this.returnAspectRatio();
          // generate image
          const im = document.createElement('img');
          im?.setAttribute('src', this.returnPlaceholder());
          im?.setAttribute('alt', url);
          im?.setAttribute('style', `aspect-ratio: ${this.returnAspectRatio()}; background: white`);
          im?.setAttribute('loading', `eager`);
          if (cta) {
            im?.addEventListener('click', () => this.handleClickSide(cta));
          }
          intersectionObserver(im, src);
          if (!!moreinfo) {
            //generate icon
            const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            icon?.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            icon?.setAttributeNS(null, 'viewBox', '0 0 24 24');
            icon?.setAttributeNS(null, 'stroke-width', '1.5');
            icon?.setAttributeNS(null, 'stroke', jpc ? '#ffffff' : '#808080');
            icon?.setAttributeNS(null, 'fill', 'none');
            icon?.setAttributeNS(null, 'class', 'w-6 h-6');
            icon?.setAttributeNS(null, 'width', '24');
            icon?.setAttributeNS(null, 'height', '24');
            icon?.setAttributeNS(null, 'style', `position: absolute; z-index: 11; bottom: 8px; left: ${jpc ? '50%' : '8px'};`);
            icon?.setAttributeNS(null, 'preserveAspectRatio', 'none');
            //generate icon path
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            path?.setAttribute('stroke-linecap', 'round');
            path?.setAttribute('stroke-linejoin', 'round');
            path?.setAttribute('height', '24');
            path?.setAttribute('width', '24');
            path?.setAttributeNS(
              null,
              'd',
              'M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z',
            );

            icon.addEventListener('click', () => this.handleMoreInfoClick(moreinfo));
            icon.append(path);
            item.append(icon);
          }

          //append image
          item.append(im);
          //append icon
          this.swiper?.addSlide(index, item);
        }
      });
    }
  }
}
